module.exports = window["core-js/modules/es.date.to-primitive.js"];